import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmExperimentsContext: DecisionMakerProfilePageFcmExperimentsContext,
	FcmExperimentsProvider: DecisionMakerProfilePageFcmExperimentsContextProvider,
	useFcmExperiments: useDecisionMakerProfilePageFcmExperiments,
	useAsyncFcmExperiments: useAsyncDecisionMakerProfilePageFcmExperiments,
	prefetchFcmExperiments: prefetchDecisionMakerProfilePageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'DecisionMakerProfilePageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {},
	prefetch: true,
});

export type DecisionMakerProfilePageFcmExperimentsState = ReturnType<
	typeof useAsyncDecisionMakerProfilePageFcmExperiments
>;
export type DecisionMakerProfilePageFcmExperiments = LoadedStateData<DecisionMakerProfilePageFcmExperimentsState>;
